// extracted by mini-css-extract-plugin
export default {"PatientInfoPop":"PatientInfoPop_PatientInfoPop__AGNQZ","header":"PatientInfoPop_header__WZ5SK"};